import TrainerCard from "./TrainerCard";
export default TrainerCard;
